import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import '../Alumnos/AlumnoForm.css';
import '../Alumnos/MDAlumnos.css';
import * as constantClass from '../fileWithConstants';
import { MdTableCell } from '../common/MdRowActions';

function BackIcon() {
  return (
    <svg className="md-page__icon md-page__icon--sm" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M19 12H5M12 19l-7-7 7-7" />
    </svg>
  );
}

function formatResultadoLabel(resultado) {
  const value = (resultado || '').trim();
  if (value === 'R') return 'Regular';
  if (value === 'L') return 'Libre';
  return 'Sin Resultado';
}

function getResultadoBadgeClass(resultado) {
  const value = (resultado || '').trim();
  if (value === 'R') return 'md-page__badge md-page__badge--success';
  if (value === 'L') return 'md-page__badge md-page__badge--danger';
  return 'md-page__badge md-page__badge--neutral';
}

export class VerActaCursada extends Component {
  static displayName = VerActaCursada.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      loadError: '',
      alumnos: [],
      materia: '',
      id: this.props.match.params.id,
    };
  }

  componentDidMount() {
    if (constantClass.canAccess('WWActasCursado')) {
      this.populateData();
    } else {
      this.setState({ loading: false });
    }
  }

  renderTable(alumnos) {
    if (!alumnos.length) {
      return <p className="md-form-page__empty-hint">No hay alumnos en esta acta.</p>;
    }

    return (
      <div className="md-page__table-card">
        <table className="md-page__table" aria-labelledby="ver-acta-cursada-title">
          <thead>
            <tr>
              <th scope="col">DNI</th>
              <th scope="col">Nombre y Apellido</th>
              <th scope="col">Resultado</th>
            </tr>
          </thead>
          <tbody>
            {alumnos.map((alumno) => (
              <tr key={alumno.detalleActaCursadaCod}>
                <MdTableCell>{alumno.alumnoDni}</MdTableCell>
                <MdTableCell>{alumno.alumnoNombre}</MdTableCell>
                <td>
                  <span className={getResultadoBadgeClass(alumno.detalleActaCursadaResultado)}>
                    {formatResultadoLabel(alumno.detalleActaCursadaResultado)}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  render() {
    const { loading, loadError, alumnos, materia } = this.state;

    const contents = loading
      ? <p className="md-page__loading"><em>Cargando datos...</em></p>
      : this.renderTable(alumnos);

    return (
      <div className="md-page md-form-page md-ver-acta-cursada">
        <Link className="md-form-page__back" to="/md-acur">
          <BackIcon />
          Volver al listado
        </Link>

        <h1 id="ver-acta-cursada-title" className="md-form-page__title">Ver Acta de Cursada</h1>

        {materia ? (
          <p className="md-form-page__subtitle">Materia: {materia}</p>
        ) : null}

        <div className="md-form-page__feedback" aria-live="polite" role="status">
          {loadError ? (
            <div className="md-form-page__error" role="alert">{loadError}</div>
          ) : null}
        </div>

        {contents}
      </div>
    );
  }

  async populateData() {
    this.setState({ loading: true, loadError: '' });

    const { data } = await constantClass.apiFetch('api/acur/detalle/' + this.state.id, {
      method: 'GET',
    });

    if (data === 'Timeout') {
      constantClass.RedirectToLogin();
      return;
    }

    if (constantClass.isApiError(data)) {
      this.setState({
        loading: false,
        loadError: constantClass.getApiErrorMessage(
          data,
          'No se pudo cargar el detalle del acta.'
        ),
      });
      return;
    }

    const alumnos = Array.isArray(data.returnModel) ? [...data.returnModel] : [];
    alumnos.sort((a, b) => String(a.alumnoNombre).localeCompare(String(b.alumnoNombre), 'es'));

    const materia = alumnos.length > 0
      ? alumnos[0].materiaCarreraNombre.trim() + ' - ' + alumnos[0].carreraNombre.trim()
      : '';

    this.setState({
      alumnos,
      materia,
      loading: false,
    });
  }
}
